import {
  _sharedActionsConstantsLibrary,
  _sharedActionsLibrary
} from "@/shared/store/library/actions";

export const libraryActionsConstants = {
  ..._sharedActionsConstantsLibrary,
  GET_ID_AND_POSITION_TO_OPEN_BOOK: "GET_ID_AND_POSITION_TO_OPEN_BOOK",
  CANCEL_GET_ID_AND_POSITION_TO_OPEN_BOOK: "CANCEL_GET_ID_AND_POSITION_TO_OPEN_BOOK",
};

export const libraryActions = {
  ..._sharedActionsLibrary,
  getIdAndPositionToOpenBook: (
    bookId,
    isGonnaListen,
    isUseMLHistory, isUseDefaultHistory, isUseLocalHistory,
    isFetchNewestHistory,
    onSuccess,
  ) => ({
    type: libraryActionsConstants.GET_ID_AND_POSITION_TO_OPEN_BOOK,
    data: {
      bookId,
      isGonnaListen,
      isUseMLHistory, isUseDefaultHistory, isUseLocalHistory,
      isFetchNewestHistory,
      onSuccess,
    },
  }),
  cancelGetIdAndPositionToOpenBook: () => ({
    type: libraryActionsConstants.CANCEL_GET_ID_AND_POSITION_TO_OPEN_BOOK,
  }),
};
